import { action } from 'satcheljs/lib/legacy';
import { updateFolderViewState } from './folderViewStatesActions';
import getFolderViewStateFromId from 'owa-mail-folder-store/lib/selectors/getFolderViewStateFromId';
/**
 * Expands or collapses the folder
 * @param folderId - unique identifier id for a folder
 * @param doNotPersistUserConfig - should user config be updated or not
 */
export default action('toggleFolderNodeExpansion')(function (folderId, doNotPersistUserConfig) {
    var localViewState = getFolderViewStateFromId(folderId);
    localViewState.isExpanded = !localViewState.isExpanded;
    // User config is not persistent for Archive mailbox, hence we need not call this action in that case
    if (!doNotPersistUserConfig) {
        updateFolderViewState(folderId);
    }
});
//# sourceMappingURL=toggleFolderNodeExpansion.js.map